import { filterObjectKeys } from '../../../../../components/helper/ArrayObjFunctions';
import { defaultGraphLabelStyle } from '../../../../../components/helper/ColorFormatter';
import { metricsVars } from '../../../../../core/const/metricsVars';
import type { IMetricsOptions } from '../../../../../core/types/metricsTypes';
import type { chartMetricType, OptionType } from './types';

export const chartMetricsOptions: OptionType[] = [
  // (default selection for primaryMetric dropdown)
  { value: 'total_sales', label: 'Total Sales' },
  // (default selection for secondaryMetric dropdown)
  { value: 'organic_sales', label: 'Organic Sales' },

  { value: 'paid_sales', label: 'Paid Sales' },
  { value: 'sns_sales', label: 'SNS Sales' },
  { value: 'new_to_brand_customers', label: 'New To Brand Customers' },
  { value: 'repeat_sales', label: 'Repeat Sales' },
];

export const chartColors: Record<chartMetricType, string> = {
  primaryMetric: '#8BA3E5',
  secondaryMetric: '#C3D400',
};

export const chartBaseAxis = {
  show: true,
  title: { text: undefined, style: defaultGraphLabelStyle },
  min: 0,
  labels: {
    show: true,
    style: defaultGraphLabelStyle,
  },
  crosshairs: { show: false },
  tooltip: { enabled: false },
};

const chartMetrics = chartMetricsOptions.map((metric) => metric.label);
export const performanceChartMetricsProperty: Record<string, IMetricsOptions> = filterObjectKeys(
  metricsVars,
  chartMetrics,
);
